/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title case capitalizes the first letter of every word; sentence case capitalizes only the first letter of each sentence.`)
};

const es_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Case capitaliza la primera letra de cada palabra; Sentence case capitaliza solo la primera letra de cada oración.`)
};

const de_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title Case kapitalisiert den ersten Buchstaben jedes Wortes; Sentence case kapitalisiert nur den ersten Buchstaben jedes Satzes.`)
};

const nl_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titeltekst schrijft het eerste letterwoord van elk woord; zintekst schrijft alleen het eerste letterwoord van elke zin.`)
};

const fr_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La casse titre capitalise la première lettre de chaque mot ; la casse phrase capitalise uniquement la première lettre de chaque phrase.`)
};

const it_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title case capitalizza la prima lettera di ogni parola; sentence case capitalizza solo la prima lettera di ogni frase.`)
};

const pt_br2_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso de título capitaliza a primeira letra de cada palavra; caso de sentença capitaliza apenas a primeira letra de cada sentença.`)
};

const pt_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caso de título capitaliza a primeira letra de cada palavra; caso de sentença capitaliza apenas a primeira letra de cada sentença.`)
};

const ja_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title case はすべての単語の最初の文字を大文字化します。sentence case は各文の最初の文字のみを大文字化します。`)
};

const zh_cc_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标题格式会将每个单词的首字母大写；句首大写格式只将每个句子的第一个字母大写。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cc_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cc_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cc_faq3_a", locale)
	if (locale === "en") return en_cc_faq3_a(inputs)
	if (locale === "es") return es_cc_faq3_a(inputs)
	if (locale === "de") return de_cc_faq3_a(inputs)
	if (locale === "nl") return nl_cc_faq3_a(inputs)
	if (locale === "fr") return fr_cc_faq3_a(inputs)
	if (locale === "it") return it_cc_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_cc_faq3_a(inputs)
	if (locale === "pt") return pt_cc_faq3_a(inputs)
	if (locale === "ja") return ja_cc_faq3_a(inputs)
	return zh_cc_faq3_a(inputs)
};